import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getUrlSettingsByHostname } from 'graphql/queries';
import { request } from 'utilities/graph';
import useCustomAuth from 'hooks/useCustomAuth';

const UrlSettingsContext = createContext();

export function UrlSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { signOut } = useCustomAuth();

  useEffect(() => {
    const fetchUrlSettings = async () => {
      try {
        const hostname = window.location.hostname;
        const { data: { getUrlSettingsByHostname: { items: results } } } = await request(getUrlSettingsByHostname, { hostname });
        if (results.length > 0) {
          setSettings(results[0]);
        } else {
          setSettings({
            mode: 'app',
            isOfficialVersion: true,
            lineLoginEnabled: false,
          });
        }
        setLoading(false);
      } catch (err) {
        console.error('Error fetching URL settings:', err);
        if (err.message?.includes('No current user')) {
          await signOut();
        }
        setError(err);
        setLoading(false);
      }
    };

    fetchUrlSettings();
  }, []);

  const value = {
    settings,
    loading,
    error,
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading settings</div>;
  }

  return (
    <UrlSettingsContext.Provider value={value}>
      {children}
    </UrlSettingsContext.Provider>
  );
}

UrlSettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useUrlSettings() {
  const context = useContext(UrlSettingsContext);
  if (context === undefined) {
    throw new Error('useUrlSettings must be used within a UrlSettingsProvider');
  }
  return context;
}
